const utils = require('../../../lib/utils')

module.exports = {
    methods: {
        showMessage: function(content, isError = false){
            // reset styles
            const addClasses = ['visible']
            if(isError) addClasses.push('error');
            const $target = this.$.find('.messageContainer')
                .removeClass('visible')
                .removeClass('error')
                .css('opacity', 0)
                .css('height', 'auto')

            // set new message
            $target.find('.message').html(content)

            // mesaure height
            const height = $target.height()

            // animate show message
            $target
                .css('height', 0)
                .addClass(addClasses)
                .css('opacity', 1)
                .css('height', `${height}px`)
        },

        prepare: function(){
            this.find('base_form_form', form => {
                if((form.resourceData || {}).error){
                    this.model.error = form.resourceData.error
                }
                this.config.isPostAuth = (form.config || {}).isPostAuth
                return 'break'
            })
        },

        handleError: function(context){
            const apiError = utils.extractBaseError(context.error) || {};

            // TODO: POI ski-club-lofer > eventParticipantForm > fill out > restart > submit form > problem
            // if(apiError.statusCode === 404 && apiError.errorCode === 'ROUTE_NOT_FOUND_ACCORDING_TO_INDEX'){
            //     return utils.$.ajax({
            //         method: 'GET',
            //         url: ((window || {}).location || {}).href,
            //         cache: false
            //     }).fail(error => {
            //         if(apiError.statusCode <= 500){
            //             this.showMessage(`<p>${utils.i18next.__(`error:events.registration.${apiError.errorCode || apiError.statusCode}`)}</p>`, true)
            //         }
            //         context.errorUnhandled = true;
            //         return utils.promise.resolve(context);
            //     }).then(response => {
            //         return utils.promise.resolve(context);
            //     });
            // }

            if(apiError.statusCode <= 500){
                this.showMessage(`<p>${utils.i18next.__(`error:events.registration.${apiError.errorCode || apiError.statusCode}`)}</p>`, true)
            }

            context.errorUnhandled = true;
            return utils.promise.resolve(context);
        },

        getMinFuturePeriodChangeAt: function(storage){
            let referenceTS = storage.user.getReferenceTS()

            // post auth
            if(this.config.isPostAuth){
                return referenceTS
            }

            const event = (storage.request || {}).event || {}
            const eventAttributes = (event.data || {}).attributes

            if(eventAttributes){
                let ts
                for(const field of ['registrationStartTS', 'registrationEndTS', 'startTS', 'endTS']){
                    if(eventAttributes[field] && eventAttributes[field] > referenceTS && (!ts || eventAttributes[field] < ts)){
                        ts = eventAttributes[field]
                    }
                }
                return ts
            }

            return referenceTS
        },
    },

    handlers: [{
        name: 'onSubmitDone',
        componentClass: 'base_bootstrap5_events_applicantRegistrationForm',
        handle: function(callerComponent, nodeData, insertPerformed){
            if(callerComponent.config.isPostAuth) {
                this.showMessage(`<p>${utils.i18next.__(`events.registration.postAuthSubmitDone`)}</p>`, false)
            } else {
                this.showMessage(`<p>${utils.i18next.__(`events.registration.eventRegistrationMailSent`)}</p>`, false)
            }
        }
    }]
}

